export default __webpack_public_path__ + "static/media/erythree_fill.201b79cb.svg";